export function applyIntercompanySearchParamUpdates(
    current: URLSearchParams,
    updates: ReadonlyArray<{ key: string; values: readonly string[] }>,
): URLSearchParams {
    const next = new URLSearchParams(current);
    for (const { key, values } of updates) {
        next.delete(key);
        for (const value of values) {
            next.append(key, value);
        }
    }
    return next;
}
